
import {Component, Vue} from "vue-property-decorator";
import ContentPageLayout from "@/components/UI/renewal/ContentPageLayout.vue";
import CultureContent from "@/components/culture/CultureContent.vue";

@Component({
  components: {
    ContentPageLayout,
    CultureContent,
  },
})
export default class Culture extends Vue {
}
